import { Invoices } from '../../../../pages/admin-dashboard/admin-invoice/admin-invoice.model';
import { InvoiceTableRow } from './Invoice-table.model';

function toInvoiceTableRow(invoice: Invoices): InvoiceTableRow {
  return {
    id: invoice.id,
    invoiceId: invoice.id,
    orderId: invoice.orderId,
    pharmacyOwner: `${invoice.pharmacy.nickName} / ${invoice.pharmacy.pharmacyOwner.fullName}`,
    status: {
      titleEn: invoice.invoiceStatus.titleEn,
      titleAr: invoice.invoiceStatus.titleAr,
    },
    totalPharmacyPrice: invoice.totalStorePrice,
    createdOn: invoice.createdOn,
    createdBy: invoice.createdBy?.fullName ?? '-',
  };
}

export function toInvoiceTableRows(invoices: Invoices[]): InvoiceTableRow[] {
  return invoices.map((invoice) => toInvoiceTableRow(invoice));
}
